// Non-shell session screens (session & auth-state handling, 2026-10-06).
// Rendered by App for every session state other than ACTIVE. None of them
// shows firm data or lifecycle / security internals.
import React from 'react';
import PendingInvitations from './PendingInvitations';

const wrap = { minHeight: '100vh', background: '#080a10', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', boxSizing: 'border-box', fontFamily: "'DM Sans', sans-serif" };
const card = { maxWidth: '520px', width: '100%', textAlign: 'center' };
const h2 = { color: '#e8eaed', margin: '0 0 0.75rem' };
const p = { color: '#8b8fa3', lineHeight: 1.6, margin: '0 0 1.5rem' };
const button = { padding: '0.75rem 2rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '10px', color: '#e8eaed', cursor: 'pointer', fontSize: '0.9rem', fontFamily: 'inherit', margin: '0 0.35rem' };

const Invites = ({ invites, currentFirmId, displayName }) => (invites && invites.length > 0 ? (
  <div style={{ textAlign: 'left', marginBottom: '1.5rem' }}>
    <PendingInvitations invites={invites} currentFirmId={currentFirmId} displayName={displayName} onAccepted={() => window.location.reload()} />
  </div>
) : null);

// Suspended (or any other inactive membership status). Accepted invite policy
// (inviteAcceptanceService D2): a suspended member may still accept an
// invitation to another firm, so pending invitations stay available here.
export const SuspendedAccess = ({ inactive = false, invites = [], currentFirmId = null, displayName = '', onSignOut }) => (
  <div style={wrap} role="main" aria-label="Access suspended">
    <div style={card}>
      <h2 style={h2}>{inactive ? 'Access unavailable' : 'Access suspended'}</h2>
      <p style={p}>
        {inactive ? 'Your access to this firm is currently unavailable.' : 'Your access to this firm is currently suspended.'} Please contact your firm administrator.
      </p>
      <Invites invites={invites} currentFirmId={currentFirmId} displayName={displayName} />
      <button type="button" style={button} onClick={onSignOut}>Sign Out</button>
    </div>
  </div>
);

// Removed / firmless: only the account-level invitation experience.
export const NoFirmAccess = ({ invites = [], displayName = '', onSignOut }) => (
  <div style={wrap} role="main" aria-label="No firm access">
    <div style={card}>
      <h2 style={h2}>No firm access</h2>
      <p style={p}>
        {invites.length > 0
          ? 'You are not currently a member of a firm on FirmAssist. You can accept a pending invitation below.'
          : 'You are not currently a member of a firm on FirmAssist. Ask your firm administrator to send you a new invitation.'}
      </p>
      <Invites invites={invites} currentFirmId={null} displayName={displayName} />
      <button type="button" style={button} onClick={onSignOut}>Sign Out</button>
    </div>
  </div>
);

// Transient failure: never treated as removal / suspension / firm loss.
export const SessionRetry = ({ onRetry, onSignOut }) => (
  <div style={wrap} role="main" aria-label="Connection problem">
    <div style={card}>
      <h2 style={h2}>We couldn't confirm your access</h2>
      <p style={p}>FirmAssist couldn't reach the server to confirm your account. Check your connection — we'll keep trying automatically.</p>
      <button type="button" style={button} onClick={onRetry}>Try again</button>
      <button type="button" style={button} onClick={onSignOut}>Sign Out</button>
    </div>
  </div>
);

// Cleanup in progress, or a reload the loop-guard refused to automate.
export const SessionBusy = ({ reloadRequired = false }) => (
  <div style={wrap} role="main" aria-label="Securing session">
    <div style={card}>
      <h2 style={h2}>{reloadRequired ? 'Please reload FirmAssist' : 'Securing your session…'}</h2>
      <p style={p}>
        {reloadRequired
          ? 'Your account access changed. Close any other FirmAssist tabs, then reload this page.'
          : 'Your account access changed. Clearing this device’s firm data…'}
      </p>
      {reloadRequired && <button type="button" style={button} onClick={() => window.location.reload()}>Reload</button>}
    </div>
  </div>
);
